import userApi from '@editor/api/user';
import { useUserStore } from '@editor/stores/userStore';

type DesignLockFunction = (
  designId: string
) => Promise<{ error?: string; success?: boolean }>;

// It's possible to call a function returned by this hook before user state is
// initialised. In such a case `user.isTeam` is `undefined`. To handle this, we
// try to (un)lock the project anyway, at the risk of causing an error with the
// API, but preventing users being locked out of their design or losing work.
const isMaybeTeam = (): boolean => {
  const user = useUserStore.getState().user;
  const isTeam = user ? user.isTeam : null;

  return isTeam || isTeam === undefined;
};

/** Hook for interacting with design locks */
export const useDesignLocks = (): {
  lockDesign: DesignLockFunction;
  unlockDesign: DesignLockFunction;
} => {
  const lockDesign: DesignLockFunction = (designId) => {
    if (isMaybeTeam() && designId) {
      return userApi.lockDesign(designId);
    }

    return Promise.resolve({});
  };

  const unlockDesign: DesignLockFunction = (designId) => {
    if (isMaybeTeam() && designId) {
      return userApi.unlockDesign(designId);
    }

    return Promise.resolve({});
  };

  return { lockDesign, unlockDesign };
};
